module.exports = __webpack_public_path__ + "static/img/14.18986da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/eng/14.png
// module id = 4cta
// module chunks = 0